<template>
	<div class="boardBackground" :style="nowWidth < 1090 ? 'height:auto' : ''">
		<v-layout justify-center wrap align-center>
			<!-- waitings List -->
			<v-flex xs12>
				<v-layout class="mb-2">
					<div class="board-title">
						{{ headTxt }}
						<!-- <span class="board-info ml-2">※ 대기번호가 대시보드에 표시 되었을때 입장을 진행해주세요.</span> -->
					</div>
					<v-spacer></v-spacer>
					<div class="text-right">
						<v-img
							v-if="$route.params.code === 'yl3rnpvlhr'"
							src="/logo_change_board_yl3rnpvlhr.png"
							width="240"
							height="60"
							contain
						></v-img>
						<v-img v-else src="/gs-logo.png" width="60" height="60" contain></v-img>
						<!-- <v-img :src="serverUrl + logoUrl" width="83" height="60"></v-img> -->
					</div>
				</v-layout>
			</v-flex>
			<!-- 호출 번호  -->
			<v-flex xs12 class="waitListFlex" v-if="nowWidth > 1090">
				<v-layout flex-wrap>
					<v-flex xs3 class="numBar">대기번호</v-flex>
					<v-flex xs3 class="numBar">전화번호 </v-flex>
					<v-flex xs3 class="numBar right">대기번호</v-flex>
					<v-flex xs3 class="numBar">전화번호 </v-flex>
				</v-layout>
				<div class="parentBox" :key="key">
					<v-layout flex-wrap align-center class="waiting-border-setting" v-for="(waiting, i) in waitings" :key="i">
						<v-flex xs6 class="waitingList">
							<v-layout align-center>
								<v-flex xs6>
									<div>
										{{ waiting.Num1 }}
									</div>
								</v-flex>
								<v-flex xs6>
									<div>
										{{ waiting.phone1 }}
									</div>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 class="waitingList right">
							<v-layout align-center>
								<v-flex xs6>
									<div>
										{{ waiting.Num2 }}
									</div>
								</v-flex>
								<v-flex xs6>
									<div>
										{{ waiting.phone2 }}
									</div>
								</v-flex>
							</v-layout></v-flex
						>
					</v-layout>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {
	data() {
		return {
			serverUrl: '',
			headTxt: '테스트 고객 상담현황',
			logoUrl: '',
			waitings: [
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
				{ phone1: '', Num1: '', phone2: '', Num2: '' },
			],
			screenWidth: 0,
			voiceList: [], // 음성 재생 데이터
			called: [], // call한 고객 Data
			bottomSlice: 0, // 하단 상담석 리스트 slice point
			bottomEnd: 0,
			calledUser: { seat: '', waitnum: '' }, // 현재 부른 고객
			counselorData: [], // 카운셀러 데이터
			socket: '',
			waitingsListViews: [],
			resetNumber: 0,
			key: 0,
		}
	},
	mounted() {
		this.reservedays()
		this.reserveusers()
		setInterval(() => {
			this.reserveusersConnection()
		}, 1500)
	},
	created() {
		this.screenWidth = window.innerWidth
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		reserveusersConnection() {
			const data = {
				code: this.$route.params.code,
				sdate:
					this.$moment()
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
				reserveState: 'visit',
			}
			this.$store.dispatch('reserveusersConnection', data).then(res => {
				if (this.resetNumber !== res.data.reserveusersConnection.aggregate.count) {
					this.reserveusers()
				}
				this.resetNumber = res.data.reserveusersConnection.aggregate.count
			})
		},
		async reserveusers() {
			const data = {
				code: this.$route.params.code,
				sdate:
					this.$moment()
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
				reserveState: 'visit',
				limit: 30,
			}
			await this.$store.dispatch('findReserveusers', data).then(res => {
				const sorting = res.data.reserveusers.sort(function(a, b) {
					var nameA = a.waitingnum // ignore upper and lowercase
					var nameB = b.waitingnum // ignore upper and lowercase
					if (nameA > nameB) {
						return -1
					}
					if (nameA < nameB) {
						return 1
					}

					// 이름이 같을 경우
					return 0
				})
				for (let index = 0; index < sorting.length; index++) {
					const el = sorting[index]
					if (index < 15) {
						this.waitings[index] = {
							...this.waitings[index],
							Num1: el.waitingnum,
							phone1: el.phone.substr(el.phone.length - 4, el.phone.length),
						}
					} else {
						this.waitings[index - 15] = {
							...this.waitings[index - 15],
							Num2: el.waitingnum,
							phone2: el.phone.substr(el.phone.length - 4, el.phone.length),
						}
					}
				}
				this.key += 1
			})
		},
		reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				this.headTxt = res.data.reservedays[0].title
			})
		},
	},
}
</script>

<style lang="scss">
.next-waitng-datas-layout {
	height: auto;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	padding: 0px 16px;
	border-radius: 22px;
}
.next-waitng-datas {
	margin-left: 8px;
	white-space: nowrap;
	font-size: 2.5vw;
	color: #d8d8d8;
	span {
		color: #f6ffdb;
		font-size: 3vw;
	}
}
.board-title {
	.board-info {
		color: yellow;
		font-size: 24px;
		font-weight: bold;
	}
	color: #d8d8d8;
	font-size: 35px;
	font-weight: bold;
}
body::-webkit-scrollbar {
	width: 0 !important;
	display: none !important;
}
.boardNoscroll {
	overflow: hidden !important;
	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important; /* Firefox */
}
.boardNoscroll::-webkit-scrollbar {
	width: 0px;
	display: none !important; /* Chrome, Safari, Opera */
}
</style>
<style lang="scss" scoped>
.boardBackground {
	padding: 16px;
	background: #1a1a22;
	height: 100vh;
}
.boardHead {
	background: url('/image/header_bg.jpg');
	color: white;
	font-size: 6vh;
	font-weight: bold;
	text-align: center;
	padding: 3vh 0px;
}
.leftContent {
	text-align: center;
	height: 88vh;
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	padding: 0px 16px;
	border-radius: 22px;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
}
.leftContent1 {
	text-align: center;
	// height: 85vw;
	text-align: -webkit-center;
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	padding: 16px;
	border-radius: 22px;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
}
.waitListFlex {
	height: 88vh;
	padding: 16px;
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	border-radius: 22px;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
}
.waitNum {
	color: white;
	font-size: 400px;
	font-weight: bold;
	line-height: 300px;
	height: 300px;
	// margin: 9vh 5vw 5vh 5vw;
	text-align: -webkit-center;
}
.waitNum1 {
	color: white;
	// padding: 10vw 0vw 0vw 0vw;
	font-size: 40vw;
	font-weight: bold;
	margin: 0vh 5vw 0vh 5vw;
	text-align: -webkit-center;
	height: 58vw;
}
.seatInfo {
	color: #f08300;
	font-size: 6vh;
	font-weight: bold;
	margin: 9vh 5vw 5vh 5vw;
}

.numBar {
	&.right {
		border-left: 1px solid #5b5b5b;
	}
	color: #d8d8d8;
	font-size: 40px;
	font-weight: bold;
	text-align: center;
	padding-bottom: 10px;
}
.waiting-border-setting {
	border-top: 1px solid #535353;
	border-bottom: 1px solid #535353;
}
.waitingList {
	&.right {
		border-left: 1px solid #5b5b5b;
	}
	height: 40px;
	line-height: 40px;
	color: #f6ffdb;
	font-size: 40px;
	font-weight: bold;
	text-align: center;
	// padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.waitingListBig {
	line-height: 0px;
	color: #f6ffdb;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.waitingList1 {
	line-height: 0px;
	color: #afefff;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.waitingList1Big {
	line-height: 0px;
	color: #afefff;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.called {
	background: #004e50;
}

.callCustomer {
	font-size: 3vw;
	text-align: center;
	font-weight: bold;
	border-style: solid;
	border-width: 3px 0px 0px 0px;
	border-color: white;
	border-style: solid;
	color: white;
	height: 18.1vh;
}
.callCustomer1 {
	font-size: 6.7vw;
	margin-bottom: 24vw !important;
	text-align: center;
	font-weight: bold;
	color: white;
	height: 20vw;
}
.boardLogo {
	margin-top: -4.5vh;
}
.hideBtns {
	display: none;
}
.bottomWaiting1 {
	text-align: center;
	// width: 30vw;
	min-width: 16vw;
	max-width: 16vw;
	color: white;
	font-size: 3.6vw;
	font-weight: 500;
	font-weight: 500;
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
	// border-style: solid;
	// border-width: 1px 0px 0px 0px;
	// border-color: #ffffff7d;
	// border-style: solid;
}
.bottomWaiting {
	text-align: center;
	width: 20vw;
	color: white;
	font-size: 3.6vw;
	font-weight: 500;
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
}
.bottomWait {
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
	padding: 3.9vw 0vw;
	height: 13.7vw;
}
.bottomWait1 {
	color: #9fd8f7;
	padding: 3.9vw 0vw;
	height: 13.7vw;
}
.bottomWaitNum {
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
	padding: 2.865vw 0vw;
	font-weight: bold;
	font-size: 5vw;
	height: 13.7vw;
}
.bottomWaitNum1 {
	color: #9fd8f7;
	padding: 2.865vw 0vw;
	font-weight: bold;
	font-size: 5vw;
	height: 13.7vw;
}
.parentBox {
	height: 77vh;
	display: flex;
	flex-direction: column;
	border: 1px solid #5b5b5b;
	border-radius: 11px;
}

.grayBack {
	background: #202020;
	flex-grow: 1;
}
.blackBack {
	flex-grow: 1;
}
.headInfo {
	padding: 80px 0px 0px 0px !important;
	color: #d8d8d8;
	font-size: 60px;
	font-weight: bold;
}
.headInfo1 {
	margin: 8% 0px 0px 0px !important;
	color: #d8d8d8;
	font-size: 11.5vw;
	font-weight: bold;
}
.toSeat {
	white-space: nowrap;
	color: white;
	font-weight: 500;
	font-size: 5vw;
	// line-height: 8vw;
	// margin-top: 40px;
	span {
		color: #afefff;
		font-weight: 700;
		font-size: 8vw;
	}
}
.toSeat1 {
	white-space: nowrap;
	color: white;
	font-weight: 500;
	font-size: 7vw;
	margin: -2vw 0px 7vw 0px !important;
	span {
		font-weight: bold;
		font-size: 11vw;
	}
}
</style>
